import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Table } from 'antd';
import FormModal from './FormModal';
@inject('connectionMonitorStore')
@observer
class SearchResult extends Component {
  state={
    addModalVisible: false,
    record: null
  }
  componentDidMount() {
    const { connectionMonitorStore } = this.props;
    const {searchItem} = connectionMonitorStore
    connectionMonitorStore.onSearchMonitorAction(searchItem)
  }
  handleStart=(record)=>{
    const { connectionMonitorStore } = this.props;
    connectionMonitorStore.onStartMonitorAction(record.id);
  }
  handleStop=(record)=>{
    const { connectionMonitorStore } = this.props;
    connectionMonitorStore.onStopMonitorAction(record.id);
  }
  handleDetail=(record)=>{
    this.setState({
      addModalVisible: true,
      record: record
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  handlePageChange = (page, pageSize) => {
    const { connectionMonitorStore } = this.props;
    connectionMonitorStore.onChangePageNumAction(page, pageSize);
  }
  render() {
    const { connectionMonitorStore } = this.props
    const { pageNo, pageSize, itemCount, connectionMonitorList } = connectionMonitorStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
      return (
        <>
          <Table className='searchResult' dataSource={toJS(connectionMonitorList)} pagination={pagination} rowKey="id" size="small" bordered onRow={record => {
            return {
              onClick: event => {this.handleDetail(record)}, // 点击行
            };
          }}>
            <Table.Column title='Channel Name' dataIndex="channelName" key="channelName" />
            <Table.Column title='Status' dataIndex="status" key="status" />
            <Table.Column title='Process Status' dataIndex="processStatus" key="processStatus" />
            <Table.Column title='Short Log' dataIndex="shortLog" key="shortLog" />
            <Table.Column title='Partner' dataIndex="partner" key="partner" />
            <Table.Column title='Partner Component' dataIndex="partnerComponent" key="partnerComponent" />
            <Table.Column title='Partner Namespace' dataIndex="partnerNamespace" key="partnerNamespace" />
          </Table>
          {this.state.addModalVisible?<FormModal
            addModalVisible={this.state.addModalVisible}
            handleCancel={this.handleCancel}
            record={this.state.record}
          />:null}
        </>
      );
  }
}

export default SearchResult;
